import { render } from "./Overlay.vue?vue&type=template&id=155c35d2&scoped=true"
import script from "./Overlay.vue?vue&type=script&setup=true&lang=js"
export * from "./Overlay.vue?vue&type=script&setup=true&lang=js"

import "./Overlay.vue?vue&type=style&index=0&id=155c35d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-155c35d2"],['__file',"src/components/modals/Overlay.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "155c35d2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('155c35d2', __exports__)) {
    api.reload('155c35d2', __exports__)
  }
  
  module.hot.accept("./Overlay.vue?vue&type=template&id=155c35d2&scoped=true", () => {
    api.rerender('155c35d2', render)
  })

}


export default __exports__